import { Component, HostBinding, EventEmitter, Output, ElementRef } from '@angular/core';
import { Session } from '../services/session';

import { HELP_CENTER_ARTICLES } from '@lib/customer-support.const';

@Component({
  selector: 'eld-onboarding-banner',
  templateUrl: './eld-onboarding-banner.component.html',
})
export class EldOnboardingBannerComponent {
  @Output() public onBannerClose = new EventEmitter();
  @Output() public onBannerOpen = new EventEmitter();
  public readonly installAndAssignTheELDUrl: string = HELP_CENTER_ARTICLES.INSTALL_AND_ASSIGN_THE_ELD;
  public readonly addDriverToYourCompanyArticleUrl: string = HELP_CENTER_ARTICLES.ADD_DRIVERS_TO_YOUR_COMPANY;
  private el: HTMLElement;

  constructor(private session: Session, el: ElementRef) {
    this.el = el.nativeElement;
  }

  @HostBinding('class.hide')
  public get shouldAddHideClass(): boolean {
    const addHideClass: boolean = !this.hasNoAssignedElds && !this.hasNoEldDrivers;
    const isHidden: boolean = this.el.classList.contains('hide');
    if (addHideClass && !isHidden) setTimeout(() => this.onBannerClose.emit(), 0);
    else if (!addHideClass && isHidden) this.onBannerOpen.emit();
    return addHideClass;
  }

  public get unassignedElds() {
    return this.session.unassignedElds();
  }

  public get hasNoAssignedElds() {
    const session = this.session;
    return this.unassignedElds > 0 && session.assignedElds() === 0;
  }

  public get hasNoEldDrivers() {
    const session = this.session;
    return session.userPermissions.isDriversManageAllowed() && session.assignedElds() > 0 && session.eldEnabledDrivers() === 0;
  }
}
